import moment from 'moment';

const OffersAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const getStatus = (i) => {
    if (i?.status === 'pending') {
      if (moment().isAfter(moment(i?.date_from, 'YYYY-MM-DD'), 'day')) {
        return 'status_expired';
      } else {
        return 'status_new';
      }
    } else {
      return i?.status;
    }
  };

  const prepareData = (i) => ({
    ...i,
    'shopping_centers.title': i.company?.shopping_center?.title,
    'companies.title': i?.company?.title,
    'extrastocks.title': i?.extrastock?.title,
    status: getStatus(i),
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export const FormValuesAdapter = (values) => {
  const formData = new FormData();
  for (let key in values) {
    switch (key) {
      case 'date_to':
      case 'date_from': {
        if (values[key]) {
          formData.append(
            `extrastock_offer[${key}]`,
            values[key].format('YYYY-MM-DD'),
          );
        }
        break;
      }
      case 'offer_date': {
        if (values[key]) {
          formData.append(
            `extrastock_offer[${key}]`,
            values[key].format('YYYY-MM-DD HH:mm:ss'),
          );
        }
        break;
      }
      case 'contract_file':
      case 'end_rent_file':
      case 'hot_file_signed':
      case 'rent_file': {
        if (values[key].length) {
          formData.append(
            `extrastock_offer[${key}]`,
            values[key][0].originFileObj,
          );
        } else {
          // formData.append(`facility_request[${key}]`, []);
        }
        break;
      }
      default: {
        formData.append(`extrastock_offer[${key}]`, values[key] || '');
      }
    }
  }
  return formData;
};

export default OffersAdapter;
